export enum EquipmentType {
    CHEMICAL_TANK = 'ChemicalTank',
    PIPELINE = 'Pipeline',
    MILK_TANK = 'MilkTank',
}
